import React from 'react'
import Helmet from 'react-helmet'
import { SECTIONS } from '../../utils/url'
import Donate from '../../pages/_donation-form';
import PageLayout from './PageLayout';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import { createRichTextOptions } from '../../utils/richTextReactRendering';
import Paperform from '../../components/common/Paperform';

export default class DonationPageLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            location: ''
        }
    }

    static getDerivedStateFromProps(props, state) {
        const { location } = props;
        return {
            location: location ? location.search : ''
        }
    }

    getStateFromStorage() {
        this.state = { 
            donate : {
                amount:  typeof window !== 'undefined' && (window.history.state && window.history.state.data ? window.history.state.data.donateAmount : 50),
                reason: typeof window !== 'undefined' && (window.history.state && window.history.state.data ? window.history.state.data.donateReason: ''),
                recurring: typeof window !== 'undefined' && (window.history.state && window.history.state.data ? window.history.state.data.recurring: '')
            },
            pageContext: {
                partner: ""
            }
        }
    }
    componentDidMount() {
        const { slug } = this.props.pageDonation;

        sessionStorage.setItem("donationSlug", slug);
    }

    render() {
        const { site, preview, pageDonation, location, sitemap } = this.props
        const prefillValue = location ? location.search : '';
        this.getStateFromStorage();
        if(!site) site = {title: ''}
        const topRichText = preview && pageDonation ? pageDonation.topRichText : pageDonation && pageDonation.topRichText && JSON.parse(pageDonation.topRichText.raw)
        const downRichText = preview && pageDonation ? pageDonation.downRichText : pageDonation && pageDonation.downRichText && JSON.parse(pageDonation.downRichText.raw)
        const optionsTop = createRichTextOptions(pageDonation?.topRichText?.references, {})
        const optionsDown = createRichTextOptions(pageDonation?.downRichText?.references, {})

        return pageDonation && (
            pageDonation.paperform ? (
                <PageLayout className="donate" activeSection={SECTIONS.SUPPORT_STARSHIP.key} sitemap={sitemap}>
                    <Helmet>
                        <title>{site.title} - {pageDonation.title}</title>
                    </Helmet>
                    <main className="wrapper has-sidebar">
                        <div className="content richtext-body">
                            <div>{ topRichText && documentToReactComponents(topRichText, optionsTop) }</div>
                            <Paperform slug={pageDonation.paperform.slug} prefillValue={prefillValue} />
                            <div>{ downRichText && documentToReactComponents(downRichText, optionsDown) }</div>
                        </div>
                    </main>
                </PageLayout>
            ) :  <Donate location={location} donate={this.state.donate} pageContext={this.state.pageContext}/> 
            )
    }
}